/**
 * Meuble
 */
import CustomObject from "./CustomObject.js";

export default class Furniture extends CustomObject {
  constructor(modelPath, position, id, rotation) {
    super(modelPath, position, id, rotation);
    this.type = "furniture";
    this.collisionAllowed = true;
    this.snappingAllowed = true;

    /**
     * Exception meubles colonnes Chicago
     */
    console.log(this.id);
    
    if (this.id === "6632300-B" || this.id === "3700970") {
      this.axesMove = [true, true, true];
    } else {
      this.axesMove = [true, false, true];
    }


  }
}
